/**
 * Global menu visibility via Application Setting `menu.hiddenHrefs`.
 * JSON array of paths, e.g. ["/deviation","/reports"].
 */

export const MENU_HIDDEN_HREFS_SETTING_KEY = 'menu.hiddenHrefs';

/** Always hidden from the sidebar (merged with Application Setting `menu.hiddenHrefs`). */
export const DEFAULT_MENU_HIDDEN_HREFS = ['/capa'];

/** Paths that remain reachable even if listed in menu.hiddenHrefs. */
export const MENU_HIDE_EXEMPT_PATH_PREFIXES = [
  '/application-settings',
  '/login',
  // Schedule deep links / Open report — keep year analytics reachable if hub `/reports` is hidden
  '/report-scheduling',
  '/reports/complaint',
  '/reports/risk-assessment',
  '/reports/deviation',
  '/reports/product-status-change',
  '/reports/todo',
  '/reports/ticketing',
  '/reports/manuals',
  '/reports/contracts',
  '/reports/schedules',
];

/**
 * @param {string|{ value?: string }|null|undefined} settingValue — raw `value` or API row
 * @returns {string[]}
 */
export function parseHiddenMenuHrefs(settingValue) {
  if (settingValue == null) return [];

  let raw = settingValue;
  if (typeof settingValue === 'object' && settingValue !== null && 'value' in settingValue) {
    raw = settingValue.value;
  }

  if (typeof raw !== 'string') return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];

  try {
    const parsed = JSON.parse(trimmed);
    if (Array.isArray(parsed)) {
      return parsed
        .filter((h) => typeof h === 'string' && h.startsWith('/'))
        .map((h) => (h.length > 1 ? h.replace(/\/+$/, '') : h));
    }
  } catch {
    /* comma-separated fallback */
  }

  return trimmed
    .split(/[\s,]+/)
    .map((s) => s.trim())
    .filter((h) => h.startsWith('/'))
    .map((h) => (h.length > 1 ? h.replace(/\/+$/, '') : h));
}

/**
 * @param {string} pathname
 * @param {string[]} hiddenHrefs
 */
export function isPathHiddenByMenuSetting(pathname, hiddenHrefs) {
  if (!pathname || !hiddenHrefs?.length) return false;

  const normalized = pathname.replace(/\/+$/, '') || '/';

  for (const prefix of MENU_HIDE_EXEMPT_PATH_PREFIXES) {
    const p = prefix.replace(/\/+$/, '') || '/';
    if (normalized === p || normalized.startsWith(`${p}/`)) return false;
  }

  for (const h of hiddenHrefs) {
    if (h === '/') continue;
    if (normalized === h || normalized.startsWith(`${h}/`)) return true;
  }
  return false;
}
